module.exports = __webpack_public_path__ + "static/sso-hero-68e8108c2b95980e900b61cb167b44c6.jpg";